export const SET_VERSION = "SET_VERSION";
export const SET_SESSION_INFO = "SET_SESSION_INFO";